import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "../../components/layout/Layout";
import axios from "axios";
import { APIURL } from "../../redux/action/config";
import { Formik } from "formik";
import { connect, useDispatch } from "react-redux";
import { updateFleet } from "../../redux/action/fleet";
import { ToastContainer } from "react-toastify";
import NoImage from "../../assets/images/noimages.jpg";
import { Validation } from "../../utills/Validation";
import loader from "../../components/loader/loader";

const initialState = { alt: "", src: "" };

const EditFleet = () => {
  const [activeLoader, setActiveLoader] = useState(false);
  const [{ alt, src }, setPreview] = useState(initialState);
  const [img, setImg] = useState();
  const [loading, setLoading] = useState(true);

  const fileHandler = (event) => {
    const { files } = event.target;

    const token = localStorage.getItem("token");
    var formdata = new FormData();
    formdata.append("image", event.target.files[0]);
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${token}`);
    var requestOptions = {
      method: "POST",
      body: formdata,
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${APIURL}/api/v1/image`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.status == "success") {
          setActiveLoader(false);
          setImg(result.data.images.image);
        }
      })
      .catch((error) => console.log("error", error));
    setPreview(
      files.length
        ? {
            src: URL.createObjectURL(files[0]),
            alt: files[0].name,
          }
        : initialState
    );
    setActiveLoader(true);
  };

  const [FleetDetails, setFleetDetails] = useState();
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    setLoading(true);
    const token = localStorage.getItem("token");
    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios
      .get(`${APIURL}/api/v1/fleets/${id}`, config)
      .then((response) => {
        setPreview({ src: APIURL + "/" + response.data.data.fleet.image });

        setFleetDetails(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);
  const fleet = FleetDetails?.data?.fleet ? FleetDetails?.data?.fleet : "";

  return (
    <React.Fragment>
      <ToastContainer autoClose={2000} />
      <Layout title="Edit Fleet" page="editFleet">
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          <div id="kt_content_container" className="container-fluid">
            {!loading && fleet?.id ? (
              <div className="row">
                <div className="col-xl-8 offset-xl-2">
                  <div className="card card-flush h-lg-100">
                    <div className="card-header pt-7">
                      <div className="card-title">
                        <span className="svg-icon svg-icon-1 me-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M20 14H18V10H20C20.6 10 21 10.4 21 11V13C21 13.6 20.6 14 20 14ZM21 19V17C21 16.4 20.6 16 20 16H18V20H20C20.6 20 21 19.6 21 19ZM21 7V5C21 4.4 20.6 4 20 4H18V8H20C20.6 8 21 7.6 21 7Z"
                              fill="black"
                            ></path>
                            <path
                              opacity="0.3"
                              d="M17 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H17C17.6 2 18 2.4 18 3V21C18 21.6 17.6 22 17 22ZM10 7C8.9 7 8 7.9 8 9C8 10.1 8.9 11 10 11C11.1 11 12 10.1 12 9C12 7.9 11.1 7 10 7ZM13.3 16C14 16 14.5 15.3 14.3 14.7C13.7 13.2 12 12 10.1 12C8.10001 12 6.49999 13.1 5.89999 14.7C5.59999 15.3 6.19999 16 7.39999 16H13.3Z"
                              fill="black"
                            ></path>
                          </svg>
                        </span>
                        <h2>Manage Fleet</h2>
                      </div>
                    </div>
                    <div className="card-body pt-5">
                      <Formik
                        initialValues={{
                          name: fleet?.name,
                          vehicle_model: fleet?.vehicle_model,
                          year: fleet?.year,
                          color: fleet?.color,
                          registration_no: fleet?.registration_no,
                          fuel_type: fleet?.fuel_type,
                          license_plate: fleet?.license_plate,
                          status: fleet?.status,
                        }}
                        // validationSchema={Validation}
                        onSubmit={(values) => {
                          if (img !== "undefined") {
                            values.image = img;
                          } else {
                            values.image = fleet?.image;
                          }
                          dispatch(updateFleet(values, id));
                        }}
                      >
                        {({
                          values,
                          handleBlur,
                          handleChange,
                          handleSubmit,
                          errors,
                          touched,
                        }) => (
                          <form className="form" onSubmit={handleSubmit}>
                            <div className="row mb-8">
                              <div className="col-xl-3">
                                <div className="fs-6 fw-bold mt-2 mb-3">
                                  Fleet Badge
                                </div>
                              </div>
                              <div className="col-lg-8">
                                <div
                                  className="image-input w-125px h-125px image-input-outline"
                                  style={{
                                    backgroundImage: `url(${src || NoImage})`,
                                  }}
                                >
                                  <label
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="change"
                                    data-bs-toggle="tooltip"
                                    title="Change avatar"
                                    data-bs-original-title="Change avatar"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="16"
                                      height="16"
                                      fill="currentColor"
                                      className="bi bi-pencil"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"></path>
                                    </svg>
                                    <input
                                      id="file-input"
                                      accept="image/*"
                                      type="file"
                                      onChange={fileHandler}
                                    />
                                    <input type="hidden" name="avatar_remove" />
                                  </label>
                                  <span
                                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-white shadow"
                                    data-kt-image-input-action="cancel"
                                    data-bs-toggle="tooltip"
                                    title="Cancel avatar"
                                    data-bs-original-title="Cancel avatar"
                                  >
                                    <i className="bi bi-x fs-2"></i>
                                  </span>
                                  {activeLoader == true ? (
                                    <div
                                      className="d-flex align-items-center justify-content-center h-100"
                                      style={{ background: "#e2e2e270" }}
                                    >
                                      <div
                                        className="spinner-border w-80"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div className="form-text">
                                  Allowed file types: png, jpg, jpeg.
                                </div>
                              </div>
                            </div>
                            <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Fleet Name</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="name"
                                    id="name"
                                    defaultValue={
                                      fleet?.name ? fleet?.name : values.name
                                    }
                                  />
                                  {errors.fleet?.name && touched.fleet?.name ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.name}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Model</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="vehicle_model"
                                    id="vehicle_model"
                                    defaultValue={
                                      fleet?.vehicle_model
                                        ? fleet?.vehicle_model
                                        : values.vehicle_model
                                    }
                                  />
                                  {errors.fleet?.vehicle_model &&
                                  touched.fleet?.vehicle_model ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.vehicle_model}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Year</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="year"
                                    id="year"
                                    defaultValue={
                                      fleet?.year ? fleet?.year : values.year
                                    }
                                  />
                                  {errors.fleet?.year && touched.fleet?.year ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.year}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Color</span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="color"
                                    id="color"
                                    defaultValue={
                                      fleet?.color ? fleet?.color : values.color
                                    }
                                  />
                                  {errors.fleet?.color &&
                                  touched.fleet?.color ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.color}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="row row-cols-1 row-cols-sm-2 rol-cols-md-1 row-cols-lg-2">
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">
                                      Registration Number
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="registration_no"
                                    id="registration_no"
                                    defaultValue={
                                      fleet?.registration_no
                                        ? fleet?.registration_no
                                        : values.registration_no
                                    }
                                  />
                                  {errors.fleet?.registration_no &&
                                  touched.fleet?.registration_no ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.registration_no}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">
                                      License Plate
                                    </span>
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control form-control-solid"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    name="license_plate"
                                    id="license_plate"
                                    defaultValue={
                                      fleet?.license_plate
                                        ? fleet?.license_plate
                                        : values.license_plate
                                    }
                                  />
                                  {errors.fleet?.license_plate &&
                                  touched.fleet?.license_plate ? (
                                    <div className="text-danger mt-2">
                                      {errors.fleet?.license_plate}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col">
                                <div className="fv-row mb-7 fv-plugins-icon-container">
                                  <label className="fs-6 fw-bold form-label mt-3">
                                    <span className="required">Fuel Type</span>
                                  </label>
                                  <select
                                    className="form-select form-control form-control-solid"
                                    aria-label="Select example"
                                    name="fuel_type"
                                    id="fuel_type"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    defaultValue={fleet.fuel_type}
                                  >
                                    <option
                                      value="Fuel Type"
                                      selected={
                                        fleet.fuel_type === "Fuel Type"
                                          ? true
                                          : false
                                      }
                                    >
                                      Fuel Type
                                    </option>
                                    <option
                                      value="Diesel"
                                      selected={
                                        fleet.fuel_type === "Diesel"
                                          ? true
                                          : false
                                      }
                                    >
                                      Diesel
                                    </option>
                                    <option
                                      value="Petrol"
                                      selected={
                                        fleet.fuel_type === "Petrol"
                                          ? true
                                          : false
                                      }
                                    >
                                      Petrol
                                    </option>
                                    <option
                                      value="Electric"
                                      selected={
                                        fleet.fuel_type === "Electric"
                                          ? true
                                          : false
                                      }
                                    >
                                      Electric
                                    </option>
                                    <option
                                      value="CNG"
                                      selected={
                                        fleet.value === "CNG" ? true : false
                                      }
                                    >
                                      CNG
                                    </option>
                                    {errors?.fleet?.fuel_type &&
                                    touched?.fleet?.fuel_type ? (
                                      <div className="text-danger mt-2">
                                        {errors?.fleet?.fuel_type}
                                      </div>
                                    ) : null}
                                  </select>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-5">
                              <label className="fs-6 fw-bold form-label mt-3">
                                <span className="required">Status</span>
                              </label>
                              <select
                                className="form-select form-control form-control-solid"
                                aria-label="Select example"
                                name="status"
                                id="status"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                defaultValue={
                                  fleet?.status ? fleet?.status : values.status
                                }
                              >
                                <option
                                  value="available"
                                  label="Available"
                                  selected={
                                    fleet.status === "available" ? true : false
                                  }
                                >
                                  Available
                                </option>
                                <option
                                  value="busy"
                                  label="Busy"
                                  selected={
                                    fleet.status === "busy" ? true : false
                                  }
                                >
                                  Busy
                                </option>
                                <option
                                  value="out_of_service"
                                  label="Out of Service"
                                  selected={
                                    fleet.status === "out_of_service"
                                      ? true
                                      : false
                                  }
                                >
                                  Out of Service
                                </option>
                              </select>
                              <div className="fv-plugins-message-container invalid-feedback"></div>
                            </div>
                            <div className="separator mb-6"></div>
                            <div className="d-flex justify-content-end">
                              <Link
                                to="/manage-fleet"
                                type="reset"
                                data-kt-contacts-type="cancel"
                                className="btn btn-light me-3"
                              >
                                Cancel
                              </Link>
                              <button type="submit" className="btn btn-primary">
                                <span className="indicator-label">Save</span>
                              </button>
                            </div>
                            <div></div>
                          </form>
                        )}
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              loader()
            )}
          </div>
        </div>
      </Layout>
    </React.Fragment>
  );
};
export default connect(null, { updateFleet })(EditFleet);
